var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.diff)?_c('div',_vm._l((_vm.chunks),function(chunk,index){return _c('span',{key:("text-" + index),class:{
      'green lighten-4': chunk.added,
      'red lighten-4': chunk.removed,
    }},[_vm._v(_vm._s(chunk.value))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }